import script from "./TagEditorOrganism.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagEditorOrganism.vue?vue&type=script&setup=true&lang=ts"

import "./TagEditorOrganism.css?vue&type=style&index=0&id=65d0c27d&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65d0c27d"]])

export default __exports__